<template>
  <div>
    <performance-setups />
  </div>
</template>
<script>
import performanceSetups from "@/components/CompanySetups/performanceSetups/performanceSetups";
export default {
  name:"Performance Setup",
  components:{
    performanceSetups
  }
}
</script>